const CallButton = ({ phoneNumber }) => {
    return (
        <button
            onClick={() => {
                if (phoneNumber) {
                    window.location.href = `tel:${phoneNumber}`;
                }
            }}
            className="btn btn-sm badge bg-danger-transparent ms-1 w-25 py-2"
        >
            <i className="ri-phone-line me-1 fw-medium align-middle d-none d-md-inline"></i>
            CALL
        </button>
    )
}

export default CallButton;